var render = function () {
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"riclothes-image",class:( _obj = {}, _obj["riclothes-image--dark-theme-effect"] = this.$root.config.isDarkTheme, _obj ),style:(( _obj$1 = {}, _obj$1["border-radius"] = _vm.radius, _obj$1 )),attrs:{"src":_vm.src}})}
var staticRenderFns = []

export { render, staticRenderFns }